import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import apiService from "../../service/apiService";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";
import { dateFormatter } from "../../utilities/utillFunction";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { RTLContext } from "../../App";
import StatCard from "./StatCard";
import PaymentDetailsComponent from "./PaymetDetailComponent";
import { superAdmin, designerAdmin } from "../../lib/constants";
import { Toast } from "primereact/toast";
import * as XLSX from "xlsx";

const PaymentsDecomposition = () => {
    const serviceId = localStorage.getItem("serviceId");
    const toast = useRef(null);
    const [payments, setPayments] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [disableButton, setDisableButton] = useState(false);
    const [dateRange, setDateRange] = useState([
        new Date(moment().subtract(7, "days").format("YYYY-MM-DD")),
        new Date(moment().format("YYYY-MM-DD"))
    ]);
    const [loading, setLoading] = useState(true);
    const [masterData, setMasterData] = useState({
        "amountAccepted": 0,
        "amountPending": 0,
        "amountDeclined": 0
    });
    const [filteredPayments, setFilteredPayments] = useState([])
    const { openSidebar } = useContext(RTLContext);
    const filterOverlay = useRef(null);

    const isAdmin = useMemo(() => {
        let arr = JSON.parse(localStorage.getItem("permissions")) ?? [];
        if (arr.includes(superAdmin)) return true;
    }, []);
    useEffect(() => {
        if (!Array.isArray(payments)) {
            setFilteredPayments([]);
            return;
        }

        const query = searchQuery?.toLowerCase().trim();

        if (!query) {
            setFilteredPayments(payments);
            return;
        }

        const tempFiltered = payments.filter(payment =>
            payment.orderId?.toLowerCase().includes(query) ||
            payment.email?.toLowerCase().includes(query) ||
            payment.payee?.name?.toLowerCase().includes(query)
        );

        setFilteredPayments(tempFiltered);

    }, [payments, searchQuery]);



    const getData = async (fromDownload, DateRange) => {
        if (!fromDownload) setLoading(true)
        else {
            setDisableButton(true)
        }
        try {
            let email = localStorage.getItem("emailId");
            let orgId = localStorage.getItem("orgId");

            let nqpermissions = JSON.parse(localStorage.getItem("permissions")) || [];

            const isSuperAdmin = nqpermissions.includes(superAdmin);
            const isDesignerAdmin = nqpermissions.includes(designerAdmin);

            if (!DateRange || DateRange.length < 2) return;

            let st = moment(DateRange[0]).format("YYYY-MM-DD") + " 00:00:00";
            let ed = moment(DateRange[1]).format("YYYY-MM-DD") + " 23:59:59";

            let payment_match = {
                created_at: { $gte: st, $lte: ed }
            };
            if (fromDownload) {
                const query = searchQuery.toLowerCase();
                payment_match = {
                    ...payment_match,
                    $or: [
                        { "payee.name": { $regex: query, $options: "i" } },
                        { "email": { $regex: query, $options: "i" } },
                        { "orderId": { $regex: query, $options: "i" } },


                    ]
                }
            }

            if (isDesignerAdmin) {
                payment_match["merchantKey"] = orgId;
            } else if (!isSuperAdmin) {
                payment_match["payee.designerID"] = email;
            }


            let payment_q = {
                operation: "aggregate",
                aggregate: [
                    { $match: payment_match },
                    { $sort: { created_at: -1 } },

                ],
            };
            if (!fromDownload) {
                let project = {
                    status: 1,
                    amount: 1,
                    paymentMethod: 1,
                    "payee.name": 1,
                    "payee.customerName": 1,
                    email: 1,
                    created_at: 1,
                    orderId: 1
                }
                payment_q.aggregate.push({
                    $project: project
                })
            }
            const result = await apiService.httpDBService(
                payment_q,
                "imaginehome_master_db",
                "nq-payment-transactions"
            );
            if (fromDownload) {
                return result;
            }

            if (result?.length) {
                let amountAccepted = 0;
                let amountPending = 0;
                let amountDeclined = 0;

                result.forEach(payment => {
                    const amount = parseFloat(payment.amount) || 0;

                    if (payment.status === "Success") amountAccepted += amount;
                    else if (payment.status === "Processing") amountPending += amount;
                    else if (payment.status === "Failed") amountDeclined += amount;
                });


                setMasterData({
                    amountAccepted,
                    amountPending,
                    amountDeclined
                });

                setPayments(result);
            } else {
                setPayments([]);
            }

        } catch (error) {
            console.error("Payment Fetch Error:", error?.response || error);
        } finally {
            if (!fromDownload) setLoading(false)
            else {
                setDisableButton(false)
            }

        }
    };


    const formatCurrency = (value) => {
        if (value == null || value === "") return "";
        return `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const Icons = {
        order: "/icons/order.svg",
        payment: "/icons/payment.svg",
        clients: "/icons/clients.svg"
    }

    const getStatusBadge = (status) => {
        const statusConfig = {
            "Success": { label: "Accepted", color: "#32BF59", bgColor: "#D1FAE5" },
            "Processing": { label: "Pending", color: "#FFC409", bgColor: "#FEF3C7" },
            "Failed": { label: "Declined", color: "#C5000F", bgColor: "#FEE2E2" }
        };

        const config = statusConfig[status] || { label: status, color: "#6B7280", bgColor: "#F3F4F6" };

        return (
            <span className="status-badge-new" style={{

                color: config.color,
                backgroundColor: config.bgColor
            }}>
                {config.label}
            </span>
        );
    };

    const showPaymentDetails = (row) => {
        const openSideBar = () => {
            openSidebar(<PaymentDetailsComponent paymentId={row["orderId"]} paymentDetails={row} />)
        }
        return (
            <p
                onClick={openSideBar}
                style={{
                    cursor: "pointer",
                    fontWeight: "700",
                    fontSize: "16px",
                    color: "#000"
                }}
                className="font-bold text-lg p-2"
            >
                view
            </p>
        );
    }

    const onDownload = async () => {
        if (!filteredPayments?.length) {
            toast.current.show({
                severity: "warn",
                summary: "No Data",
                detail: "No payments available to export.",
                life: 3000
            });
            return;
        }
        else if (disableButton) {
            toast.current.show({
                severity: "warn",
                summary: "Downalod",
                detail: "Please wait downlaod in process",
                life: 3000
            });
            return;
        }

        // Fetch data (filtered by dateRange)
        const data = await getData(true, dateRange);

        // Map to Excel-friendly structure
        const exportData = data.map(item => ({
            "Payment ID": item.orderId || "",
            "Date": dateFormatter(item.created_at, "M/D/YY", "YYYY-MM-DD HH:mm:ss"),
            "Client Name": item.payee?.customerName || item.payee?.name || item.email || "",
            "Client ID": item.payee?.customer || "",
            "Email": item.email || "",
            "Payment Method": item.paymentMethod || "",
            "Payment Gateway": item.paymentGateway || "",
            "Amount": item.amount ? Number(item.amount).toFixed(2) : "0.00",
            "Currency": item.currency || "",
            "Status": item.status || "",
            "Merchant ID": item.merchantId || "",
            "Merchant Name": item.merchantName || "",
            "Surcharge Fee": item.surcharge_fee ? Number(item.surcharge_fee).toFixed(2) : "0.00",
            "Response Text": item.response?.resptext || "",
            "Response Amount": item.response?.amount || "",
            "Ref ID": item.retref || "",
            "Token": item.token || "",
        }));

        // File name
        const fileName = `payments_${moment().format("YYYY-MM-DD")}.xlsx`;

        // Create worksheet & workbook
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

        // Export
        XLSX.writeFile(workbook, fileName);
    };


    const handleDateChange = (e) => {
        const [formattedStartDate, formattedEndDate] = e.value;
        const temp = [];
        if (formattedStartDate) temp.push(formattedStartDate);
        if (formattedEndDate) temp.push(formattedEndDate);
        setDateRange(temp);
    };

    useEffect(() => {
        if (dateRange && dateRange.length > 1) {
            getData(false, dateRange);
        }
    }, []);

    return (
        <div className="font-larken p-0" style={{ background: "#FBF9F3", minHeight: "100vh", padding: "20px" }}>
            <Toast ref={toast} />
            <div className="grid justify-content-center col-12 m-0 p-0 mb-4">
                <div className="col-12 grid justify-content-between align-items-center flex-wrap" >
                    <h2 className=" m-0 charcoal-color lg:col-4 col-12" style={{ whiteSpace: "nowrap", fontFamily: "Inter" }}>Payments</h2>

                    <div className="grid align-items-center order-controls col-12 lg:col-7 gap-2 flex-wrap">
                        <div className=" lg:col-6 col-12">
                            <span className="p-input-icon-left w-full">
                                <i className="pi pi-search" />
                                <InputText
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Search"
                                    className="w-full"
                                    style={{
                                        borderRadius: "20px",
                                        boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                        border: "1px solid #ddd",
                                        background: "white",
                                        height: "40px",
                                        padding: "10px 12px 10px 40px",
                                        fontSize: "14px",
                                        fontFamily: "Inter"
                                    }}
                                />
                            </span>
                        </div>

                        <div className="lg:col-3 col-12">
                            <Button
                                icon="pi pi-filter"
                                label="Filter"
                                onClick={(e) => filterOverlay.current.toggle(e)}
                                style={{
                                    background: "white",
                                    height: "40px",
                                    boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                    border: "1px solid #ddd",
                                    color: "#3d3d3d",
                                    borderRadius: "20px",
                                    padding: "10px 20px",
                                    whiteSpace: "nowrap"

                                }}
                                className="p-button-outlined col-12 hide-label-laptop"
                            />
                        </div>
                        <div className="lg:col-3 col-12">
                            <Button
                                icon="pi pi-download"
                                label="Export"
                                disabled={disableButton || !filteredPayments.length}
                                onClick={onDownload}
                                style={{
                                    background: "white",
                                    height: "40px",
                                    boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                    border: "1px solid #ddd",
                                    color: "#3d3d3d",
                                    borderRadius: "20px",
                                    padding: "10px 20px",
                                    whiteSpace: "nowrap"
                                }}
                                className="p-button-outlined col-12 hide-label-laptop"
                            />
                        </div>
                    </div>

                    {/* Filter Overlay Panel */}
                    <OverlayPanel ref={filterOverlay} className="col-12 lg:col-5">
                        <div className="p-5 grid ">

                            <Calendar
                                id="range"
                                value={dateRange}
                                placeholder="Select Date Range"
                                onChange={handleDateChange}
                                selectionMode="range"
                                 maxDate={new Date()}
                                readOnlyInput
                                className="col-12  text-sm md:text-base"
                                dateFormat="dd-mm-yy"
                                inline
                            />
                            <div className="col-12 flex  mt-3 gap-2">
                                <Button
                                    label="Clear"
                                    className="p-button-text"
                                    onClick={() => {
                                        const newRange = [
                                            new Date(moment().subtract(7, "days").format("YYYY-MM-DD")),
                                            new Date(moment().format("YYYY-MM-DD"))
                                        ];
                                        setDateRange(newRange);
                                        getData(false, newRange);
                                    }}
                                />
                                <Button
                                    label="Apply"
                                    onClick={() => {
                                        filterOverlay.current.hide()
                                        getData(false, dateRange);
                                    }

                                    }
                                    style={{ backgroundColor: "#9AAB89", border: "none" }}
                                />
                            </div>
                        </div>
                    </OverlayPanel>
                </div>
                <div className="grid justify-content-between col-12">
                    {/* Amount Accepted */}
                    <StatCard label={"Amount Accepted"} value={formatCurrency(masterData.amountAccepted)} />

                    {/* Amount Pending */}
                    <StatCard label={"Amount Pending"} value={formatCurrency(masterData.amountPending)} />

                    {/* Amount Declined */}
                    <StatCard label={"Amount Declined"} value={formatCurrency(masterData.amountDeclined)} />
                </div>
            </div>
            {/* Data Table */}
            <div className="col-12 mt-2">
                <DataTable
                    loading={loading}
                    value={filteredPayments}
                    paginator={true}
                    rows={10}
                    responsiveLayout="scroll"
                    emptyMessage="No payments found"
                    className="w-full card-table"
                    rowClassName={() => 'card-row'}
                    style={{ background: "transparent" }}
                >
                    <Column
                        header="Payment ID"
                        body={(row) => `#${row.orderId?.substring(0, 4)}`}
                        bodyClassName="dataTableHeader" headerClassName="text-lg font-bold"
                    />
                    <Column
                        header="Date"
                        body={(row) => dateFormatter(row.created_at, "M/D/YY", "YYYY-MM-DD HH:mm:ss")}
                        bodyClassName="dataTableHeader" headerClassName="text-lg font-bold"
                    />
                    <Column
                        header="Client"
                        body={(row) => row.payee?.name || row.payee?.customerName || row.email}
                        bodyClassName="dataTableHeader" headerClassName="text-lg font-bold"
                    />
                    <Column
                        header="Payment Method"
                        body={(row) => {
                            const method = row.paymentMethod?.toUpperCase();

                            return method;
                        }}
                        bodyClassName="dataTableHeader" headerClassName="text-lg font-bold"
                    />
                    <Column
                        header="Amount"
                        body={(row) => formatCurrency(row.amount)}
                        bodyClassName="dataTableHeader" headerClassName="text-lg font-bold"

                    />
                    <Column
                        header="Status"
                        body={(row) => getStatusBadge(row.status)}
                        bodyClassName="dataTableHeader" headerClassName="text-lg font-bold"
                    />
                    <Column
                        body={showPaymentDetails}
                        bodyClassName="dataTableHeader" headerClassName="text-lg font-bold"

                    />
                </DataTable>
            </div>
        </div>
    );
};

export default PaymentsDecomposition;